import React, { useEffect, useState } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Link, Button, Dialog, DialogContent, IconButton, TextField } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { CloseOutlined } from '@mui/icons-material';
import { ApiGetInvoiceItem, ApiUpdateInvoiceItem } from '../../../apiService/Core/Apicall.tsx';
import { Edit } from 'lucide-react';
import edit from '../../../assets/images/editIcon.png'
import { number } from 'yup';
import { toast } from 'react-toastify';


function Invoicedetails({ selectedDate }) {
    const location = useLocation()
    const navigate = useNavigate()
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const [bigImg, setbigImg] = useState<boolean>(false)
    const [showImg, setshowImg] = useState<any>([])
    const [invoiceItem, setInvoiceItem] = useState<any>([]);
    const [editIndex, setEditIndex] = useState(null);
    const [editedValues, setEditedValues] = useState({
        bonus: '',
        penalty: '',
    });



    function createData2(
        img: any,
        visitDate: string,
        Venue: string,
        Score: number,
        Price: number,
        Food: string,
        Bar: string,
        Gaming: number,
        Battleshop: string,
        Bonus: string,
        pennulty: string,
        total: number,
    ) {
        return { img, visitDate, Venue, Score, Price, Food, Bar, Gaming, Battleshop, Bonus, pennulty, total };
    }


    const images = showImg.length > 0 && showImg?.map(img => ({
        original: img,
        thumbnail: img,
    }));

    const getInvoiveItem = async () => {
        setInvoiceItem([])
        try {
            // const data = `?userId=${userData.userId}&month=${selectedDate.month() + 1}&year=${selectedDate.year()}`
            const data = `?shopperInvoiceId=${location?.state?.shopperInvoiceId}`
            const res = await ApiGetInvoiceItem(data)
            setInvoiceItem(res.data.invoiceList)
        } catch (error) {
            alert(error)
        }

    }
    useEffect(() => {
        getInvoiveItem()
    }, [selectedDate])

    const handleEditClick = (index, row) => {
        setEditIndex(index);
        setEditedValues({
            bonus: row.bonus || '',
            penalty: row.penalty || '',
        });
    };

    const handleSaveClick = async (index) => {
        const invoice = invoiceItem[index]
        const data = {
            shopperInvoiceItemId: invoice.shopperInvoiceItemId,
            shopperInvoiceId: invoice.shopperInvoiceId.shopperInvoiceId,
            reportHdrId: invoice.reportHdrId,
            clientGroupName: invoice.clientGroupName,
            newBonusAmount: Number(editedValues.bonus),
            newPenaltyAmount: Number(editedValues.penalty)
        }
        // Perform save operation here (API call, state update, etc.)
        console.log("Save values for index", data);
        const res = await ApiUpdateInvoiceItem(data);
        toast.success(res.message)
        getInvoiveItem()
        // Reset edit state
        setEditIndex(null);
        setEditedValues({
            bonus: '',
            penalty: '',
        });
    };

    const handleChange = (field, value) => {
        setEditedValues((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <Box bgcolor={'#fff'} padding='20px'>
            <Typography variant='subtitle1' className='mb-3'><Link href='/dashboard/invoices' className='text-main' sx={{ textDecorationColor: '#ABD792' }} onClick={() => { navigate(-1) }}>invoices</Link> / Invoice: #{location?.state?.shopperInvoiceId}</Typography>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{ bgcolor: "#7a7d52" }}>
                        <TableRow>
                            {/* <TableCell sx={{width:'50px'}}></TableCell> */}
                            <TableCell sx={{ color: 'white' }}>Visit Date</TableCell>
                            <TableCell sx={{ color: 'white' }}>Venue</TableCell>
                            <TableCell sx={{ color: 'white' }}>Score</TableCell>
                            <TableCell sx={{ color: 'white' }}>Price</TableCell>
                            <TableCell sx={{ color: 'white' }}>Food</TableCell>
                            <TableCell sx={{ color: 'white' }}>Bar</TableCell>
                            <TableCell sx={{ color: 'white' }}>Gaming</TableCell>
                            <TableCell sx={{ color: 'white' }}>Bottelshop</TableCell>
                            <TableCell sx={{ color: 'white' }}>Bonus</TableCell>
                            <TableCell sx={{ color: 'white' }}>Penalty</TableCell>
                            <TableCell sx={{ color: 'white' }}>Total</TableCell>
                            <TableCell sx={{ color: 'white' }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {invoiceItem.length > 0 ? (invoiceItem?.map((row, index) => (
                            <React.Fragment>
                                <TableRow
                                    key={index}
                                    // className='flex-wrap'
                                    sx={{ 'td,th': { border: 0 } }}
                                >
                                    <TableCell>
                                        {row.visitDate}
                                    </TableCell>
                                    <TableCell>{row?.venueName}</TableCell>
                                    <TableCell>{row?.reportScore}</TableCell>
                                    <TableCell>{row?.venuePriceDisplay}</TableCell>
                                    <TableCell>{row?.spentFoodAmt}</TableCell>
                                    <TableCell>{row?.spentBarAmt}</TableCell>
                                    <TableCell>{row?.spentGamingAmt}</TableCell>
                                    <TableCell>{row?.spentBottleShopAmt}</TableCell>
                                    <TableCell>
                                        {editIndex === index ? (
                                            <TextField
                                                type='number'
                                                size="small"
                                                value={editedValues.bonus}
                                                onChange={(e) => handleChange("bonus", e.target.value)}
                                            />
                                        ) : (
                                            row.bonus
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {editIndex === index ? (
                                            <TextField
                                                type='number'
                                                size="small"
                                                value={editedValues.penalty}
                                                onChange={(e) => handleChange("penalty", e.target.value)}
                                            />
                                        ) : (
                                            row.penalty
                                        )}
                                    </TableCell>
                                    <TableCell>{row?.finalPayableAmt}</TableCell>
                                    <TableCell>
                                        {editIndex === index ? (
                                            <Button
                                                variant="contained"
                                                color="success"
                                                size="small"
                                                onClick={() => handleSaveClick(index)}
                                            >
                                                Save
                                            </Button>
                                        ) : (
                                            <IconButton
                                                size="small"
                                                onClick={() => handleEditClick(index, row)}
                                            >
                                                <Box component='img' className='w-75' src={edit} />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={12}>
                                        <Box display="flex" gap={1}>
                                            {row?.images?.map((item, index) => (
                                                <Box
                                                    key={index}
                                                    component="img"
                                                    src={item?.imageUrl}
                                                    alt={`img-${index}`}
                                                    height="100px"
                                                    width="100px"
                                                    borderRadius="5px"
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setbigImg(true);
                                                        setshowImg(row?.images?.map(item => item?.imageUrl).filter(url => url))
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))) : <TableRow><TableCell colSpan={12} className='text-center'><Typography>No Data Found</Typography></TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog className='fulldialog' open={bigImg} onClose={() => { setbigImg(false) }}>
                <DialogContent>
                    <Box position='relative' sx={{
                        maxHeight: 'calc(100vh - 500px) !important',
                        // backgroundColor: 'green',
                        '.image-gallery-center': {
                            backgroundColor: 'transparent',
                            maxHeight: 'calc(100vh - 180px)!important'
                        },
                        '.image-gallery-svg': {
                            color: '#ADB792'
                        }
                    }}>
                        <IconButton
                            onClick={() => setbigImg(false)}
                            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10, }}
                        >
                            <CloseOutlined sx={{ fontSize: '48px' }} />
                        </IconButton>
                        <ImageGallery items={images} showPlayButton={false} />
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>

    )
}

export default Invoicedetails
